module.exports = __webpack_public_path__ + "img/regist-card-reader.0b438f3c.jpg";